import { createSelector } from '@ngrx/store';
import { IRemoteXPACPortalState, IXpacProxyState } from '../../utils/interfaces/store.interfaces';

export const selectSales = (state: IRemoteXPACPortalState) => state.xpacProxy;

export const selectXpacProxyPermissions = createSelector(
  selectSales,
  (state: IXpacProxyState) => state.permission
);